'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PreviewContainer = styled.div.withConfig({
  displayName: "Preview__PreviewContainer",
  componentId: "sc-1kkpcx6-0"
})(({
  theme
}) => ({
  height: '30px',
  width: '30px',
  display: 'inline-block',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: theme.borderRadius['100'],
  boxShadow: '0 0 2px #808080 inset',
  backgroundImage: "url('data:image/png;base64,R0lGODdhCgAKAPAAAOXl5f///ywAAAAACgAKAEACEIQdqXt9GxyETrI279OIgwIAOw==')",
  cursor: 'pointer'
}));
const PreviewInner = styled.span.withConfig({
  displayName: "Preview__PreviewInner",
  componentId: "sc-1kkpcx6-1"
})(({
  theme,
  $backgroundColor,
  $opacity
}) => ({
  position: 'absolute',
  display: 'block',
  height: '100%',
  width: '30px',
  borderRadius: theme.borderRadius['100'],
  boxShadow: '0 0 2px #808080 inset',
  backgroundColor: $backgroundColor,
  opacity: $opacity
}));
const PreviewInput = styled.input.withConfig({
  displayName: "Preview__PreviewInput",
  componentId: "sc-1kkpcx6-2"
})(({
  theme
}) => ({
  position: 'absolute',
  display: 'block',
  height: '100%',
  width: '30px',
  borderRadius: theme.borderRadius['100'],
  boxShadow: '0 0 2px #808080 inset',
  opacity: 0
}));
export default class Preview extends Component {
  constructor(...args) {
    super(...args);
    this.onChange = evt => {
      this.props.onChange({
        hex: evt.target.value
      });
      evt.stopPropagation();
    };
  }
  render() {
    const {
      hex
    } = this.props;

    // @bend-expect trellis-tokenized
    return /*#__PURE__*/_jsxs(PreviewContainer, {
      "data-test-id": "color-preview",
      children: [/*#__PURE__*/_jsx(PreviewInner, {
        $backgroundColor: hex,
        $opacity: this.props.alpha / 100
      }), /*#__PURE__*/_jsx(PreviewInput, {
        type: "color",
        defaultValue: hex,
        onChange: this.onChange,
        onClick: this.props.onInputClick
      })]
    });
  }
}
Preview.propTypes = {
  hex: PropTypes.string,
  alpha: PropTypes.number,
  onChange: PropTypes.func,
  onInputClick: PropTypes.func
};